import { initializeApp } from "firebase/app";
import { initializeAnalytics, type Analytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCTaLcjjToCpwVVI4y1wiLnuOR4xv2CNhk",
  authDomain: "gothic-state-330514.firebaseapp.com",
  projectId: "gothic-state-330514",
  storageBucket: "gothic-state-330514.appspot.com",
  messagingSenderId: "107428276961",
  appId: "1:107428276961:web:911488355a09157d4665a0",
  measurementId: "G-CCJNLWXVZN",
};

const app = initializeApp(firebaseConfig);
let analytics: Analytics | null = null;

if (typeof window !== "undefined" && import.meta.env.PROD) {
  analytics = initializeAnalytics(app, {
    config: { send_page_view: false },
  });
}

export { app, analytics };
